import React,{Component} from 'react';
import Home from './component/homepage';
class App extends Component{
    render(){
        return(
            <Home></Home>
        );
    }
}
export default App;